import React from 'react';

const Button = ({ className, label, onClick, disabled }) => (
  <button className={className} onClick={onClick} disabled={disabled}>
    <div>{label}</div>
  </button>
);

export default Button;
